'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024 from "./presto.types$-Two-Factor-Auth-Id$.js";
var $p;
/** @constructor */
function $c_Lpresto_TwoFactorAuthView$$anon$1(outer) {
  this.bAk = null;
  this.bAi = null;
  this.bAj = false;
  this.bAg = null;
  this.bAh = false;
  this.bAl = false;
  this.bAm = false;
  if ((outer === null)) {
    throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_NullPointerException__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_NullPointerException());
  }
  this.bAk = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_TwoFactorAuthView$$anon$1 as $c_Lpresto_TwoFactorAuthView$$anon$1 };
$p = $c_Lpresto_TwoFactorAuthView$$anon$1.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_TwoFactorAuthView$$anon$1;
/** @constructor */
function $h_Lpresto_TwoFactorAuthView$$anon$1() {
}
export { $h_Lpresto_TwoFactorAuthView$$anon$1 as $h_Lpresto_TwoFactorAuthView$$anon$1 };
$h_Lpresto_TwoFactorAuthView$$anon$1.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.ad = (function() {
  return this.bAk;
});
$p.t = (function() {
  if ((!this.bAj)) {
    this.bAi = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bAj = true;
  }
  return this.bAi;
});
$p.ae = (function() {
  if ((!this.bAh)) {
    this.bAg = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_presto$002etypes$0024$002dTwo$002dFactor$002dAuth$002dId$0024.$m_Lpresto_types$TwoFactorAuthId$().v9(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$());
    this.bAh = true;
  }
  return this.bAg;
});
$p.w = (function() {
  if ((!this.bAm)) {
    this.bAl = false;
    this.bAm = true;
  }
  return this.bAl;
});
$p.ac = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_TwoFactorAuthView$$anon$1 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_TwoFactorAuthView$$anon$1, "presto.TwoFactorAuthView$$anon$1", ({
  Sd: 1,
  a: 1,
  k: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_TwoFactorAuthView$$anon$1 as $d_Lpresto_TwoFactorAuthView$$anon$1 };
//# sourceMappingURL=presto.-Two-Factor-Auth-View$$anon$1.js.map
